import React, { useState, useRef } from "react";
import Lottie from "lottie-react";
import { useQueryClient } from "@tanstack/react-query";
import aiBot from "../../../../assets/animations/aiBot.json";
import {
  dangerMessage,
  successMessage,
  warningMessage,
} from "../../../Toast/Toast";
import ButtonSubmit from "../../../Buttons/ButtonSubmit";

const FormSMS = ({
  setIsSMSOpen,
  userId,
  eventID,
  eventDetails,
  token,
  isChatAiOpen,
  setIsChatAiOpen,
}) => {
  const aiRef = useRef();
  const [inputs, setInputs] = useState({});
  const [userRole, setUserRole] = useState("all");
  const [btnLoad, setBtnLoad] = useState(false);
  const [warning, setWarning] = useState("");
  const queryClient = useQueryClient();
  const key = ["allSMS", eventID];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
    setWarning("");
  };

  const allParticipantsFunc = () => setUserRole("all");
  const attendeesFunc = () => setUserRole("attendees");
  const speakersFunc = () => setUserRole("speakers");
  const teamMembersFunc = () => setUserRole("security");

  const handleSend = (e) => {
    if (e) e.preventDefault();

    if (!inputs.message?.trim()) {
      setWarning("Please type a message before submitting. The message field cannot be empty.");
      return;
    }

    setBtnLoad(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const raw = JSON.stringify({ body: inputs?.message });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API}communication/sms/${eventID}?audience=${userRole}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((res) => {
        setIsSMSOpen(false);
        setBtnLoad(false);
        if (res?.status === "success") {
          queryClient.invalidateQueries(key);
          successMessage("SMS successfully sent");
        } else {
          warningMessage("No phone number found");
        }
      })
      .catch((error) => {
        setIsSMSOpen(false);
        setBtnLoad(false);
        dangerMessage("No phone number found");
        console.error(error);
      });
  };

  return (
    <div style={styles.formContainer}>
      <form onSubmit={handleSend} noValidate style={styles.form}>
        {/* AI Helper Section */}
        <div className="mb-4 d-flex align-items-center gap-2" style={styles.aiSection}>
          <div
            className="d-flex"
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              borderWidth: 2,
              borderColor: "#F7F7F7",
              backgroundColor: "#FAF8F8",
              flexShrink: 0,
            }}
          >
            <Lottie lottieRef={aiRef} animationData={aiBot} />
          </div>
          <div style={{ fontWeight: "bold", fontSize: "14px", maxWidth: "100%" }}>
            <div>Need help with sms please use AI ? </div>
            <div
              className="text-primary"
              style={{ fontWeight: "bold", cursor: "pointer" }}
              onClick={() => setIsChatAiOpen(!isChatAiOpen)}
            >
              Click here.
            </div>
          </div>
        </div>

        {/* Message Input */}
        <label className="event__input__form__Creation" style={styles.label}>
          Message<span className="text-danger">*</span>
          <textarea
            name="message"
            value={inputs.message || ""}
            onChange={handleChange}
            style={{ borderRadius: 7, minHeight: "120px", resize: "vertical", width: "100%", boxSizing: "border-box" }}
            className="mt-1 form-control fromInput"
            rows={5}
            required
            placeholder="Type your SMS message here..."
          />
        </label>
        {warning && <p className="text-danger mt-2 small" style={{ wordWrap: "break-word" }}>{warning}</p>}

        {/* Audience Selection - HEADING AT TOP */}
        <div className="mt-3 mb-3" style={styles.audienceSection}>
          {/* ✅ HEADING AT THE TOP */}
          <div style={styles.audienceHeader}>
            <span>Select your audience</span>
            <span className="text-danger">*</span>
          </div>
          
          {/* Radio buttons wrapped in vertical container */}
          <div className="audience-radio-group" style={styles.radioGroup}>
            <div className="form-check" style={styles.radioItem}>
              <input
                className="form-check-input"
                type="radio"
                name="formatRadio"
                id="audienceAll"
                value="all"
                onChange={allParticipantsFunc}
                defaultChecked
              />
              <label className="form-check-label" htmlFor="audienceAll" style={styles.radioLabel}>
                All Participants
              </label>
            </div>
            
            <div className="form-check" style={styles.radioItem}>
              <input
                className="form-check-input"
                type="radio"
                name="formatRadio"
                id="audienceAttendees"
                value="attendees"
                onChange={attendeesFunc}
              />
              <label className="form-check-label" htmlFor="audienceAttendees" style={styles.radioLabel}>
                Attendees
              </label>
            </div>
            
            <div className="form-check" style={styles.radioItem}>
              <input
                className="form-check-input"
                type="radio"
                name="formatRadio"
                id="audienceSpeakers"
                value="speakers"
                onChange={speakersFunc}
              />
              <label className="form-check-label" htmlFor="audienceSpeakers" style={styles.radioLabel}>
                Speakers
              </label>
            </div>
            
            <div className="form-check" style={styles.radioItem}>
              <input
                className="form-check-input"
                type="radio"
                name="formatRadio"
                id="audienceSecurity"
                value="security"
                onChange={teamMembersFunc}
              />
              <label className="form-check-label" htmlFor="audienceSecurity" style={styles.radioLabel}>
                Event Security
              </label>
            </div>
          </div>
        </div>

        {/* ✅ SEND BUTTON - Ensured visible with proper spacing */}
        <div style={styles.buttonWrapper}>
          <ButtonSubmit
            Title="Send SMS"
            BackgroundColor="#f68a20"
            ColorText="white"
            BorderColor="#f68a20"
            borderRadius={20}
            handleOnclick={handleSend}
            pending={btnLoad}
            style={{
              minWidth: "120px",
              padding: "10px 24px",
              boxShadow: "0 4px 12px rgba(246, 138, 32, 0.3)",
              width: "100%",
              maxWidth: "300px",
            }}
          />
        </div>
      </form>

      {/* ✅ CSS to ENABLE vertical scrolling, PREVENT horizontal scrolling */}
      <style>{`
        /* Enable vertical scroll, prevent horizontal */
        .offcanvas-body {
          overflow-x: hidden !important;
          overflow-y: auto !important;
          padding-bottom: 30px !important;
          max-width: 100% !important;
          height: auto !important;
          max-height: calc(100vh - 100px) !important;
        }
        
        form {
          width: 100% !important;
          max-width: 100% !important;
          padding-bottom: 20px;
        }
        
        button[type="submit"],
        .btn-submit {
          position: relative !important;
          z-index: 10 !important;
          width: 100% !important;
          max-width: 300px !important;
        }
        
        /* Force vertical layout for radio buttons */
        .audience-radio-group {
          display: flex !important;
          flex-direction: column !important;
          gap: 12px !important;
          margin-top: 12px;
          width: 100% !important;
        }
        
        .audience-radio-group .form-check {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          margin-bottom: 0 !important;
          width: 100% !important;
          padding: 4px 0 !important;
        }
        
        .audience-radio-group .form-check-input {
          margin-top: 0 !important;
          flex-shrink: 0 !important;
          width: 18px !important;
          height: 18px !important;
          min-width: 18px !important;
        }
        
        .audience-radio-group .form-check-label {
          flex: 1 !important;
          cursor: pointer !important;
          white-space: normal !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
          line-height: 1.4 !important;
          margin-bottom: 0 !important;
        }
        
        /* Prevent content overflow */
        .form-control,
        textarea.form-control,
        input.form-control {
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        
        textarea.form-control {
          resize: vertical !important;
        }
        
        /* Mobile-specific fixes */
        @media (max-width: 768px) {
          .offcanvas {
            max-width: 100vw !important;
            width: 100% !important;
          }
          
          .offcanvas-body {
            overflow-y: auto !important;
            overflow-x: hidden !important;
            max-height: calc(100vh - 80px) !important;
          }
          
          .audience-radio-group {
            flex-direction: column !important;
            gap: 6px !important;
          }
          
          .audience-radio-group .form-check {
            flex-direction: row !important;
            width: 100% !important;
            align-items: center !important;
            gap: 8px !important;
            padding: 3px 0 !important;
          }
          
          /* ✅ VERY SMALL radio buttons on mobile */
          .audience-radio-group .form-check-input {
            width: 14px !important;
            height: 14px !important;
            min-width: 14px !important;
            margin: 0 !important;
          }
          
          /* ✅ Smaller labels on mobile */
          .audience-radio-group .form-check-label {
            font-size: 13px !important;
            line-height: 1.3 !important;
            padding: 0 !important;
          }
          
          .audience-header {
            font-size: 14px !important;
          }
          
          /* Ensure all text wraps properly on mobile */
          .form-check-label,
          .event__input__form__Creation,
          label,
          div {
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
            max-width: 100% !important;
          }
          
          /* Prevent horizontal scroll on mobile */
          body, html {
            overflow-x: hidden !important;
            max-width: 100vw !important;
          }
          
          /* Make AI section more compact on mobile */
          .ai-section {
            flex-direction: column !important;
            text-align: center !important;
            gap: 12px !important;
          }
          
          /* Reduce AI bot size on mobile */
          .ai-section .d-flex {
            width: 60px !important;
            height: 60px !important;
          }
        }
        
        @media (max-width: 480px) {
          .audience-section {
            padding: 10px !important;
          }
          
          /* ✅ EVEN SMALLER on very small screens */
          .audience-radio-group .form-check-input {
            width: 12px !important;
            height: 12px !important;
            min-width: 12px !important;
          }
          
          .audience-radio-group .form-check-label {
            font-size: 12px !important;
          }
          
          .audience-radio-group {
            gap: 4px !important;
          }
          
          .audience-radio-group .form-check {
            gap: 6px !important;
            padding: 2px 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

// Professional Styles - Simplified to allow scrolling
const styles = {
  formContainer: {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingBottom: "24px",
    width: "100%",
    maxWidth: "100%",
  },
  aiSection: {
    width: "100%",
    maxWidth: "100%",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "8px",
    display: "block",
    width: "100%",
    maxWidth: "100%",
  },
  audienceSection: {
    backgroundColor: "#f9fafb",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  audienceHeader: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    display: "flex",
    alignItems: "flex-start",
    gap: "2px",
    marginBottom: "12px",
    flexWrap: "wrap",
    width: "100%",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
  radioItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "0",
    width: "100%",
  },
  radioLabel: {
    flex: 1,
    cursor: "pointer",
    whiteSpace: "normal",
    fontSize: "14px",
    color: "#374151",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    lineHeight: "1.4",
  },
  buttonWrapper: {
    marginTop: "20px",
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
};

export default FormSMS;